const req = require.context('@/components/subject', true, /(.vue$)/);

const utilFuns = req.keys().map(item => req(item));
export default utilFuns;

